import React, { useEffect, useState } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeBase64Props {
  value: string;
  format?: string;
  width?: number;
  height?: number;
  fontSize?: number;
  margin?: number;
  displayValue?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const BarcodeBase64: React.FC<BarcodeBase64Props> = ({
  value,
  format = 'CODE128',
  width = 2,
  height = 100,
  fontSize = 20,
  margin = 10,
  displayValue = true,
  className,
  style,
}) => {
  const [barcodeDataUrl, setBarcodeDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (value) {
      try {
        // Tạo canvas ẩn để render barcode
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, value, {
          format,
          width,
          height,
          fontSize,
          margin,
          displayValue,
          background: 'transparent',
          lineColor: '#000',
        });
        
        // Chuyển canvas thành base64
        const dataUrl = canvas.toDataURL('image/png');
        setBarcodeDataUrl(dataUrl);
          } catch (error) {
      // Silent error handling
    }
    }
  }, [value, format, width, height, fontSize, margin, displayValue]);

  if (!barcodeDataUrl) return null;

  return (
    <img
      src={barcodeDataUrl}
      alt="Barcode"
      className={className}
      style={style}
    />
  );
};

export default BarcodeBase64; 